module.exports = __webpack_public_path__ + "static/img/statusCorrectStaticLisa.0dc18539.png";